import { Toast, Icon } from "@/components";
import { useState, type ReactNode } from "react";
import { useBlockExplorer } from "@/hooks";
import type { TransactionHash } from "@/types";
import { useLocation } from "react-router-dom";
import { ROUTES } from "@/config";
import { Link } from "@/components";

interface TransactionSuccessToastProps {
    title: string;
    transactionHash?: TransactionHash;
    children: ReactNode;
    onClose?: () => void;
}

export function TransactionSuccessToast({ onClose, transactionHash, title, children }: TransactionSuccessToastProps) {
    const [open, setOpen] = useState(true);
    const { getTransactionUrl } = useBlockExplorer();
    const location = useLocation();

    const blockExplorerUrl = transactionHash ? getTransactionUrl(transactionHash) : undefined;
    const [isPortfolioPage] = useState(location.pathname === ROUTES.PORTFOLIO);

    const handleClose = () => {
        setOpen(false);
        onClose?.();
    };

    const body = (
        <div className="flex flex-col gap-2 px-2 mb-2">
            {children}
            {blockExplorerUrl && (
                <Link
                    href={blockExplorerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 hover:text-blue-300 flex items-center gap-1 cursor-pointer"
                >
                    View Transaction
                    <span className="text-lg">↗</span>
                </Link>
            )}
            {!isPortfolioPage && (
                <Link
                    href="/portfolio"
                    className="text-blue-400 hover:text-blue-300 flex items-center gap-1 cursor-pointer"
                >
                    View Portfolio
                    <span className="text-lg">↗</span>
                </Link>
            )}
        </div>
    );

    return (
        <Toast
            open={open}
            onClose={handleClose}
            title={title}
            icon={<Icon name="CheckCircle" className="h-6 w-6 relative top-[2px]" />}
            severity="success"
        >
            <>{body}</>
        </Toast>
    );
}
